export const shellClasses = {
    hasCustomFocus: 'has-custom-focus',
    ignoreFocus: 'ignore-focus',
};
//# sourceMappingURL=shellClasses.js.map